// extracted by mini-css-extract-plugin
export default {"animatedTitle":"AnimatedTitle_animatedTitle__3w7F2","title":"AnimatedTitle_title__iu4jr","empty":"AnimatedTitle_empty__+AgGa"};